

<div >
      @if(candidature.missionTitle) {
        <div >
          <div style="display: flex; align-items: center;">
            <div class="fs-13 fw-4 text-neutral-dark">
              {{ candidature.missionTitle ?? '' }}
            </div>
            @if(candidature.isUrgent) {
            <div style="margin-left: 8px;">
              <svg-icon src="/assets/icons/redFlag.svg"></svg-icon>
            </div>
            }
          </div>
          @if(candidature.address){
         <div class="fs-11 fw-4 text-neutral-dark-grey" [matTooltip]="candidature.address">
            {{ candidature.address ? textSubstring(candidature.address, 15 ): 'N/A'}}
          </div>
          }
        </div>
      } @else {
        <div class="fs-11 text-neutral-dark-grey" >Aucune mission</div>
      }




</div>
